import React, { useEffect, useRef } from 'react';

const RemoteVideo = ({ stream }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return <video ref={videoRef} autoPlay playsInline />;
};

const VideoGrid = ({ localVideoRef, participants, remoteStreams }) => (
  <div className="row g-2">
    <div className="col-12 col-md-8">
      <div className="card h-100">
        <div className="card-header">Main Video</div>
        <div className="card-body p-0 video-tile" style={{ minHeight: 300 }}>
          <video ref={localVideoRef} autoPlay playsInline muted />
        </div>
      </div>
    </div>

    <div className="col-12 col-md-4">
      <div className="card h-100">
        <div className="card-header">Participants / Remote Video</div>
        <div className="card-body">
          {participants.map((p) => (
            <div key={p.id} className="d-flex justify-content-between mb-1">
              <strong>{p.name}</strong>
              <small className="text-muted">
                {p.joinedAt && new Date(p.joinedAt).toLocaleTimeString()}
              </small>
            </div>
          ))}
          <hr />
          {remoteStreams.length === 0 && (
            <div className="text-muted">
              No remote video yet. Ask another user to join this room.
            </div>
          )}
          {remoteStreams.map((r) => (
            <div key={r.userId} className="mb-2 video-tile" style={{ minHeight: 120 }}>
              <RemoteVideo stream={r.stream} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default VideoGrid;
